import { graphql } from "@/graphql/codegen"

graphql(`
  query GetInvoiceVendorOptions($input: CompanyListInput!) {
    company {
      list(input: $input) {
        __typename
        ... on CompanyListSuccess {
          companies {
            companyId
            publicId
            externalSystemId
            name
            types
            defaultExpenseAccountId
            locationsAssociations {
              billing {
                locationId
                address1
                address2
                city
                postalCode
                countryIsoCode
                regionIsoCode
                region {
                  shortIsoCode
                  isoCode
                }
              }
            }
          }
          pageInfo {
            total
            offset
            limit
          }
        }
        ... on CompanyListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
